<template>
  <v-layout row
            wrap>
    <v-flex xs12>
      <crud :resource="isSupplier() ? 'orderItems' : isAdmin() ? 'orderItems' : 'rawOrderItems'"
            ref="crud"
            :manager="manager"
            :extra-top-actions="extraTopActions"
            :creatable="false"
            :filters="isSupplier() ? supplierFilters : isDepartmentUser() ? clientFilters : isDepartmentHead() ? clientFilters :isPurchasingHead() ? clientFilters: adminAndOperationsFilters"
            :hiddenHeaders="isSupplier() ? supplierHiddenHeaders : []"/>
      <v-dialog v-model="selectingItems" max-width="800px">
        <v-card v-if="isSupplier()">
          <v-card-text>
            <connection-manager ref="connectionManager" v-model="connecting"/>
            <v-data-table
              v-model="selectedItems"
              :headers="headers"
              :items="items"
              select-all
              item-key="id"
              hide-actions>
              <template slot="items" slot-scope="props">
                <tr :active="props.selected" @click="props.selected = !props.selected">
                  <td>
                    <v-checkbox
                      :input-value="props.selected"
                      primary
                      hide-details/>
                  </td>
                  <td>{{ props.item.product.name }}</td>
                  <td>{{ props.item.priceAtPurchase }}</td>
                  <td>{{ props.item.quantity }}</td>
                  <td>{{ $app.formatMoney((props.item.quantity * props.item.priceAtPurchase)) }}</td>
                </tr>
              </template>
            </v-data-table>

            <guide text="It will be considered that you cannot deliver the items that are not selected"/>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="red" @click.native="selectingItems = false" flat
                   :disabled="connecting">Close
            </v-btn>
            <v-spacer/>
            <v-btn color="primary" @click.native="generateLPO"
                   :disabled="connecting || !selectedItems.length">Submit
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-else>
          <v-card-text>
            <connection-manager ref="connectionManager" v-model="connecting"/>
            <v-data-table
              v-model="selectedItems"
              :headers="departmentHeadHeaders"
              :items="items"
              select-all
              item-key="id"
              hide-actions>
              <template slot="items" slot-scope="props">
                <tr :active="props.selected">
                  <td>
                    <v-checkbox
                      :input-value="props.selected"
                      primary
                      :disabled="!props.item.quantity || props.item.quantity <= 0"
                      @click="props.selected = !props.selected"
                      hide-details/>
                  </td>
                  <td v-if="props.item.product">{{ props.item.product.name }}</td>
                  <td v-if="!props.item.product">----</td>
                  <td>
                    <span v-show="!props.item.edit">{{ props.item.quantity }}</span>
                    <span v-show="props.item.edit">
                      <v-text-field
                        v-model="props.item.quantity"
                        label="New Quantity"
                        mask="##"
                        :rules="[rules.required, rules.quantity]"
                        maxLength="10px"
                        @keyup.enter="props.item.quantity > 0 ? props.item.edit = !props.item.edit : ()=>{}"
                      ></v-text-field>
                    </span>
                  </td>
                  <td class="justify-center layout wrap px-0">
                    <span v-show="!props.item.edit">
                      <v-btn icon
                             class="mx-0"
                             @click="props.item.edit = !props.item.edit">
                        <v-icon color="success">edit</v-icon>
                      </v-btn>
                    </span>
                    <span v-show="props.item.edit">
                      <v-btn icon
                             class="mx-0"
                             :disabled="!props.item.quantity || props.item.quantity <= 0"
                             @click="props.item.edit = !props.item.edit">
                        <v-icon color="success">check</v-icon>
                      </v-btn>
                    </span>
                  </td>
                  <td>{{ props.item.priceAtPurchase }}</td>
                  <td>{{ $app.formatMoney((props.item.quantity * props.item.priceAtPurchase)) }}
                  </td>
                </tr>
              </template>
              <template slot="footer">
                <tr class='grey lighten-2'>
                  <td colspan="5">
                    <strong>Total tem cost</strong>
                  </td>
                  <td>
                    <strong>{{this.$app.formatMoney(totalCost)}}</strong>
                  </td>
                </tr>
                <tr class='grey lighten-2' v-if="isPurchasingHead()">
                  <td colspan="5">
                    <strong>Delivery cost</strong>
                  </td>
                  <td>
                    <strong>{{this.$app.formatMoney(deliveryCost)}}</strong>
                  </td>
                </tr>
                <tr class='grey lighten-2' v-if="isPurchasingHead()">
                  <td colspan="5">
                    <strong>Total amount payable</strong>
                  </td>
                  <td>
                    <strong>{{this.$app.formatMoney(amountPayable)}}</strong>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <guide text="It will be considered that you reject the items that are not selected"/>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="red" @click.native="selectingItems = false" flat
                   :disabled="connecting">Close
            </v-btn>
            <v-spacer/>
            <v-btn color="primary" @click.native="approveItems"
                   :disabled="connecting || !selectedItems.length || !selectedItemsValid()">Approve
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
  import Crud from './Crud'
  import CrudBase from './CrudBase.vue'
  import ConnectionManager from './ConnectionManager'
  import Guide from './Guide'

  export default {
    name: 'OrderedItems',
    extends: CrudBase,
    components: {
      Guide,
      ConnectionManager,
      Crud
    },
    data () {
      return {
        rules: {
          required: (value) => !!value || 'Required',
          quantity: (value) => (!!value && parseInt(value) >= 1 && parseInt(value) <= 100) || 'Quantity should be 1 - 100'
        },
        valid: true,
        connecting: false,
        selectingItems: false,
        selectedItems: [],
        adminAndOperationsFilters: [
          {value: 'PENDING_LPO', name: 'Pending LPO'},
          {value: 'ACCEPTED_BY_SUPPLIER', name: 'Accepted By Supplier'},
          {value: 'REJECTED_BY_SUPPLIER', name: 'Rejected By Supplier'},
          {value: 'RECEIVED_FROM_SUPPLIER', name: 'Received From Supplier'}
        ],
        supplierFilters: [
          {value: 'PENDING_LPO', name: 'Pending LPO'},
          {value: 'ACCEPTED_BY_SUPPLIER', name: 'Accepted'},
          {value: 'REJECTED_BY_SUPPLIER', name: 'Rejected'},
          {value: 'RECEIVED_FROM_SUPPLIER', name: 'Delivered'}
        ],
        clientFilters: [
          {value: 'AT_DEPARTMENT_HEAD', name: 'At Department Head'},
          {value: 'AT_PURCHASING_HEAD', name: 'At Purchasing Head'},
          {value: 'APPROVED', name: 'Approved'},
          {value: 'REJECTED', name: 'Rejected'}
        ],
        extraTopActions: [
          {
            name: 'Select Items To Supply',
            key: 'generateLPO'
          },
          {
            name: 'Select Items Approve',
            key: 'approveItems'
          }
        ],
        items: [],
        headers: [
          {text: 'Name', value: 'name'},
          {text: 'Price', value: 'price'},
          {text: 'Quantity', value: 'quantity'},
          {text: 'Total', value: 'total'}
        ],
        departmentHeadHeaders: [
          {text: 'Product', value: 'name'},
          {text: 'Quantity', value: 'quantity'},
          {text: '', value: 'action', sortable: false},
          {text: 'Price at Purchase', value: 'price'},
          {text: 'Amount', value: 'amount'}
        ],
        supplierHiddenHeaders: [
          {text: 'Supplier'}
        ]
      }
    },
    methods: {
      closeGeneratingLPODialog () {
        this.$refs.connectionManager.reset()
        this.selectingItems = false
        this.selectedItems = []
        this.item = null
      },
      selectedItemsValid () {
        for (let orderItem of this.selectedItems) {
          if (!orderItem.quantity || orderItem.quantity < 0) {
            return false
          }
          return true
        }
      },
      approveItems () {
        let that = this
        let orderItemIds = []
        let quantities = []
        for (let orderItem of this.selectedItems) {
          orderItemIds.push(orderItem.id)
          quantities.push(orderItem.quantity)
        }
        this.$refs.connectionManager.post('rawOrderItems/approve', {
          onSuccess (response) {
            that.$refs.crud.setItems(response.data.data)
            that.closeGeneratingLPODialog()
          }
        }, {
          items: orderItemIds.join(','), quantities: quantities.join(','), deliveryCost: that.deliveryCost
        })
      },
      generateLPO () {
        let that = this
        let orderItemIds = []
        for (let orderItem of this.selectedItems) {
          orderItemIds.push(orderItem.id)
        }
        this.$refs.connectionManager.post('orderItems/generateLPO', {
          onSuccess (response) {
            that.$refs.crud.setItems(response.data.data)
            that.closeGeneratingLPODialog()
          }
        }, {
          items: orderItemIds.join(',')
        })
      },
      initialize () {
        let that = this
        this.manager.deletable = (item) => {
          return false
        }
        this.manager.editable = (item) => {
          return false
        }
        this.manager.toValue = (header, item) => {
          let that = this
          if (header.value === 'priceAtPurchase') {
            return item.priceAtPurchase ? that.$app.formatMoney(item.priceAtPurchase) : that.$app.formatMoney(0)
          } else if (header.value === 'supplierPriceAtPurchase') {
            return item.supplierPriceAtPurchase ? that.$app.formatMoney(item.supplierPriceAtPurchase) : that.$app.formatMoney(0)
          } else if (header.value === 'product') {
            return item.product ? item.product.name : that.defaultValue
          } else if (header.value === 'amount') {
            if (that.isSupplier()) {
              return that.$app.formatMoney(item.supplierPriceAtPurchase * item.quantity)
            } else {
              return that.$app.formatMoney(item.priceAtPurchase * item.quantity)
            }
          } else if (header.value === 'supplier') {
            return (item.product && item.product.supplier) ? item.product.supplier.name : that.defaultValue
          } else {
            return item[header.value] ? item[header.value] : that.defaultValue
          }
        }
        this.manager.showTopAction = (action, items, filter) => {
          if (action.key === 'generateLPO' && filter) {
            return filter.value === 'PENDING_LPO' && items.length && this.isSupplier()
          } else if (action.key === 'approveItems' && filter) {
            if (filter.value === 'AT_DEPARTMENT_HEAD') {
              return items.length && this.isDepartmentHead()
            }
            if (filter.value === 'AT_PURCHASING_HEAD') {
              return items.length && this.isPurchasingHead()
            }
          } else {
            return true
          }
        }
        this.manager.onTopAction = (action, items, filter) => {
          that.items = items
          // that.selectingItems = action.key === 'generateLPO'
          that.selectingItems = true
        }

        this.manager.hideHeader = (header, filter) => {
          if (header.value === 'priceAtPurchase') {
            return that.isSupplier()
          }
          if (header.value === 'supplier' || header.value === 'supplierPriceAtPurchase' || header.value === 'status') {
            return that.isDepartmentUser() || that.isDepartmentHead() || that.isPurchasingHead()
          } else if (header.value === 'supplierPriceAtPurchase') {
            return that.isSupplier()
          } else {
            return false
          }
        }
      }
    },
    computed: {
      totalCost () {
        let totalCostValue = 0.0
        for (let orderItem of this.selectedItems) {
          totalCostValue += orderItem.priceAtPurchase * orderItem.quantity
        }
        return totalCostValue
      },
      amountPayable () {
        return this.deliveryCost + this.totalCost
      },
      deliveryCost () {
        let deliveryCost = 0.0
        if (this.totalCost > 0) {
          deliveryCost = 250
        }
        return deliveryCost
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OrderedItems.vue